// TODO: Artikel in die Datenbank und via ner Kategorie auf Reparatur bestimmen
export const upsellArticles = [
  { label: "W10250 - Rotor für KaVo 630/640 Premium", value: "W10250" },
  { label: "W10251 - Rotor für KaVo 650 Premium", value: "W10251" },
  { label: "W10252 - Rotor für KaVo 655/660 Premium", value: "W10252" },
  { label: "W10253 - Rotor für KaVo 7000 Premium", value: "W10253" },
  { label: "W10254 - Rotor für KaVo 8000 Premium", value: "W10254" },
  { label: "W10259 - Rotor für KaVo 642/645 Premium", value: "W10259" },
  { label: "W10274 - 10-pack KaVo Federscheibe P10015", value: "W10274" },
  { label: "W10300 - Rotor für KaVo 647/649 Premium", value: "W10300" },
  { label: "W10327 - 10-pack KaVo Federscheibe P10029", value: "W10327" },
  { label: "W10337 - Rotor für W&H TA-98(L) Premium", value: "W10337" },
  { label: "W10345 - Rotor für KaVo 5000 Premium", value: "W10345" },
  { label: "W10349 - Rotor für KaVo 637 Premium", value: "W10349" },
  { label: "W10353 - Rotor für Sirona T2/T3 Racer Premium", value: "W10353" },
  { label: "W10355 - Rotor für Bien Air Bora", value: "W10355" },
  { label: "W10359 - Rotor für W&H TA-98 LED Premium", value: "W10359" },
  { label: "W10360 - Rotor für W&H TA-96(L) Premium", value: "W10360" },
  { label: "W10394 - Rotor für NSK Ti-Max X600", value: "W10394" },
  { label: "W10431 - Rotor für Midwest Stylus Lite 360/361 Premium", value: "W10431" },
  { label: "W10442 - Rotor für NSK S-Max M600", value: "W10442" },
  { label: "W10456 - Rotor für Sirona T1 Control (TC3) Premium", value: "W10456" },
  { label: "W10458 - Rotor für W&H TA-97 (C)LED Premium", value: "W10458" },
  { label: "W10493 - Rotor für Sirona T2 Control Premium", value: "W10493" },
  { label: "W10533 - Rotor für KaVo 636/646 Premium", value: "W10533" },
  { label: "W10535 - Rotor für KaVo E680 Premium", value: "W10535" },
  { label: "W10540 - Rotor für KaVo M9000 Premium", value: "W10540" },
  { label: "W10556 - Rotor für NSK S-Max M600", value: "W10556" },
  { label: "W10560 - Rotor für KaVo E677", value: "W10560" },
  { label: "W10601 - Rotor für W&H TA-98 C LED Premium", value: "W10601" },
  { label: "W10271 - 10-pack O-ringe KaVo", value: "W10271" },
  { label: "W10273 - 10-pack O-ringe W&H, Sirona T2/T3 Racer", value: "W10273" },
  { label: "W10299 - Spannzangen Haltekraftprüfer", value: "W10299" },
  { label: "W10432 - 10-pack O-ringe 6 x 0.85", value: "W10432" },
  { label: "W10437 - 10-pack O-ringe Bien Air Bora", value: "W10437" },
  { label: "W10672 - 10-pack O-ringe NSK Ti-Max, Sirona T1 Control (TC3)", value: "W10672" },
  { label: "W10669 - O-ring Satz für MULTIflex Kupplung", value: "W10669" },
  { label: "W10298 - LED Lampe KaVo / MULTIflex", value: "W10298" },
  { label: "W10659 - LED Lampe NSK", value: "W10659" },
  { label: "W10662 - LED Lampe Sirona", value: "W10662" },
  { label: "W10660 - MULTIflex/KaVo Kupplung, 6-polig", value: "W10660" },
  { label: "W10679 - NSK Kupplung, 6-polig ", value: "W10679" },
  { label: "W10668 - Digital Einkanal Manometer", value: "W10668" },
  { label: "W10654 - Turbinenschlüssel KaVo 655/660/7000/8000", value: "W10654" },
  { label: "W10655 - Turbinenschlüssel KaVo 630/640/642/645", value: "W10655" },
  { label: "W10721 - Schlüssel f. Deckel KaVo 4500 / M9000", value: "W10721" },
  { label: "W10729 - 10-pack O-Ringe für Sirona T2 Control (6,3 x 0,8 mm)", value: "W10729" },
  { label: "W10744 - ADENSYS Spitzpinzette 105mm Edelstahl antimagnetisch", value: "W10744" },
  { label: "W10783 - Wasserfilter für KaVo Turbinen 7000/ 8000", value: "W10783" },
  { label: "W10786 - w-r.de Reparaturkit", value: "W10786" },
  { label: "W10790 - Adensys Dental Pflegeöl", value: "W10790" },
  { label: "W10791 - Spray-Adapter für ISO HWS", value: "W10791" },
  { label: "W10792 - Spray-Adapter für Spannzangenpflege", value: "W10792" },
  { label: "W10793 - Spray-Adapter für KV Multiflex", value: "W10793" },
  { label: "W10794 - Spray-Adapter für Sirona", value: "W10794" },
  { label: "W10795 - Spray-Adapter für NSK", value: "W10795" },
  { label: "W10796 - Spray-Adapter für W&H", value: "W10796" },
  { label: "W10797 - Spray-Adapter für Köpfe", value: "W10797" },
  { label: "W10800 - Rotor für NSK Ti-Max X500", value: "W10800" },
  { label: "W10801 - Rotor für NSK Ti-Max X700", value: "W10801" },
  { label: "W10802 - Rotor für Sirona T1 Control (SN >600 000)", value: "W10802" },
  { label: "W10803 - Rotor für Sirona T1 Boost (SN >600 000)", value: "W10803" },
  { label: "W10804 - Rotor für Sirona T2 Control (SN >600 000)", value: "W10804" },
  { label: "W10805 - Rotor für Sirona T2/T3 Boost  (SN >600 000)", value: "W10805" },
  { label: "W10809 - Rotor für NSK Ti-Max Z900", value: "W10809" },
  { label: "W10812 - Bundle: w-r.de Reparaturkit + Rotor + Schlüssel", value: "W10812" },
  { label: "W10813 - Universal Dental Ölspray 500ml - 6er Pack", value: "W10813" },
  { label: "W10831 - Mundschutzmaske FFP2/N95", value: "W10831" },
  { label: "W10832 - Chirurgie Maske", value: "W10832" },
  { label: "W11001 - Turbinenschlüssel f. NSK Z900", value: "W11001" },
  { label: "W11002 - Turbinenschlüssel KaVo 637", value: "W11002" },
  { label: "W11003 - Turbinenschlüssel Bien Air Bora", value: "W11003" },
  { label: "W11004 - Turbinenschlüssel KaVo 5000 / M9000", value: "W11004" },
  { label: "W11005 - Turbinenschlüssel NSK Ti-Max X500 / X700", value: "W11005" },
  { label: "W11006 - Turbinenschlüssel NSK Ti-Max X600", value: "W11006" },
  { label: "W11007 - Turbinenschlüssel Sirona T1 Control (TC3)", value: "W11007" },
  { label: "W11008 - Turbinenschlüssel Sirona T2/T3 Racer", value: "W11008" },
  { label: "W11009 - Turbinenschlüssel W&H Synea TA 97 LED / TA 98 LED", value: "W11009" },
  { label: "W11010 - Turbinenschlüssel W&H Synea TA 98 / TA 96", value: "W11010" },
  { label: "W11011 - 3-pack Reinigungsnadel", value: "W11011" },
  { label: "W11012 - Turbinendeckel KaVo 625 / 630", value: "W11012" },
  { label: "W11013 - Turbinendeckel KaVo 640", value: "W11013" },
  { label: "W11014 - Turbinendeckel Bien Air Bora", value: "W11014" },
  { label: "W11015 - Turbinendeckel KaVo 637B", value: "W11015" },
  { label: "W11016 - Turbinendeckel KaVo 647B / 649B / 650", value: "W11016" },
  { label: "W11017 - Turbinendeckel KaVo 8000 / M9000", value: "W11017" },
  { label: "W11018 - Turbinendeckel KaVo 655 / 660 / 7000", value: "W11018" },
  { label: "W11019 - Turbinendeckel W&H Synea TA 98", value: "W11019" },
  { label: "W11020 - Turbinendeckel W&H Synea TA 98 LED", value: "W11020" },
  { label: "W11021 - Turbinenschlüssel NSK S-Max M600", value: "W11021" },
];

export const upsellArticleToPrice = {
  W10250: "9500",
  W10251: "9700",
  W10252: "9700",
  W10253: "9700",
  W10254: "9900",
  W10259: "9900",
  W10274: "1250",
  W10300: "9700",
  W10327: "1250",
  W10337: "9500",
  W10345: "9900",
  W10349: "9500",
  W10353: "9500",
  W10355: "9900",
  W10359: "9500",
  W10360: "9500",
  W10394: "9500",
  W10431: "9950",
  W10442: "9700",
  W10456: "9600",
  W10458: "9600",
  W10493: "9600",
  W10533: "9700",
  W10535: "9900",
  W10540: "9600",
  W10556: "9700",
  W10560: "9900",
  W10601: "9600",
  W10271: "990",
  W10273: "990",
  W10299: "5990",
  W10432: "990",
  W10437: "990",
  W10672: "990",
  W10669: "790",
  W10298: "1990",
  W10659: "1990",
  W10662: "1990",
  W10660: "9850",
  W10679: "9850",
  W10668: "4500",
  W10654: "900",
  W10655: "2400",
  W10721: "1200",
  W10729: "990",
  W10744: "1800",
  W10783: "1190",
  W10786: "9500",
  W10790: "1490",
  W10791: "450",
  W10792: "450",
  W10793: "520",
  W10794: "520",
  W10795: "520",
  W10796: "520",
  W10797: "520",
  W10800: "9900",
  W10801: "9800",
  W10802: "9600",
  W10803: "9600",
  W10804: "9600",
  W10805: "9600",
  W10809: "9600",
  W10812: "8500",
  W10813: "8450",
  W10831: "380",
  W10832: "056",
  W11001: "2300",
  W11002: "2300",
  W11003: "2500",
  W11004: "1200",
  W11005: "1500",
  W11006: "1200",
  W11007: "1500",
  W11008: "1200",
  W11009: "1200",
  W11010: "1200",
  W11011: "399",
  W11012: "4650",
  W11013: "4650",
  W11014: "4650",
  W11015: "4650",
  W11016: "4650",
  W11017: "4650",
  W11018: "4650",
  W11019: "4650",
  W11020: "4650",
  W11021: "1500",
};

export const upsellToTitle = {
  W10250: "Rotor für KaVo 630/640 Premium",
  W10251: "Rotor für KaVo 650 Premium",
  W10252: "Rotor für KaVo 655/660 Premium",
  W10253: "Rotor für KaVo 7000 Premium",
  W10254: "Rotor für KaVo 8000 Premium",
  W10259: "Rotor für KaVo 642/645 Premium",
  W10274: "10-pack KaVo Federscheibe P10015",
  W10300: "Rotor für KaVo 647/649 Premium",
  W10327: "10-pack KaVo Federscheibe P10029",
  W10337: "Rotor für W&H TA-98(L) Premium",
  W10345: "Rotor für KaVo 5000 Premium",
  W10349: "Rotor für KaVo 637 Premium",
  W10353: "Rotor für Sirona T2/T3 Racer Premium",
  W10355: "Rotor für Bien Air Bora",
  W10359: "Rotor für W&H TA-98 LED Premium",
  W10360: "Rotor für W&H TA-96(L) Premium",
  W10394: "Rotor für NSK Ti-Max X600",
  W10431: "Rotor für Midwest Stylus Lite 360/361 Premium",
  W10442: "Rotor für NSK S-Max M600",
  W10456: "Rotor für Sirona T1 Control (TC3) Premium",
  W10458: "Rotor für W&H TA-97 (C)LED Premium",
  W10493: "Rotor für Sirona T2 Control Premium",
  W10533: "Rotor für KaVo 636/646 Premium",
  W10535: "Rotor für KaVo E680 Premium",
  W10540: "Rotor für KaVo M9000 Premium",
  W10556: "Rotor für NSK S-Max M600",
  W10560: "Rotor für KaVo E677",
  W10601: "Rotor für W&H TA-98 C LED Premium",
  W10271: "10-pack O-ringe KaVo",
  W10273: "10-pack O-ringe W&H, Sirona T2/T3 Racer",
  W10299: "Spannzangen Haltekraftprüfer",
  W10432: "10-pack O-ringe 6 x 0.85",
  W10437: "10-pack O-ringe Bien Air Bora",
  W10672: "10-pack O-ringe NSK Ti-Max, Sirona T1 Control (TC3)",
  W10669: "O-ring Satz für MULTIflex Kupplung",
  W10298: "LED Lampe KaVo / MULTIflex",
  W10659: "LED Lampe NSK",
  W10662: "LED Lampe Sirona",
  W10660: "MULTIflex/KaVo Kupplung, 6-polig",
  W10679: "NSK Kupplung, 6-polig ",
  W10668: "Digital Einkanal Manometer",
  W10654: "Turbinenschlüssel KaVo 655/660/7000/8000",
  W10655: "Turbinenschlüssel KaVo 630/640/642/645",
  W10721: "Schlüssel f. Deckel KaVo 4500 / M9000",
  W10729: "10-pack O-Ringe für Sirona T2 Control (6,3 x 0,8 mm)",
  W10744: "ADENSYS Spitzpinzette 105mm Edelstahl antimagnetisch",
  W10783: "Wasserfilter für KaVo Turbinen 7000/ 8000",
  W10786: "w-r.de Reparaturkit",
  W10790: "Adensys Dental Pflegeöl",
  W10791: "Spray-Adapter für ISO HWS",
  W10792: "Spray-Adapter für Spannzangenpflege",
  W10793: "Spray-Adapter für KV Multiflex",
  W10794: "Spray-Adapter für Sirona",
  W10795: "Spray-Adapter für NSK",
  W10796: "Spray-Adapter für W&H",
  W10797: "Spray-Adapter für Köpfe",
  W10800: "Rotor für NSK Ti-Max X500",
  W10801: "Rotor für NSK Ti-Max X700",
  W10802: "Rotor für Sirona T1 Control (SN >600 000)",
  W10803: "Rotor für Sirona T1 Boost (SN >600 000)",
  W10804: "Rotor für Sirona T2 Control (SN >600 000)",
  W10805: "Rotor für Sirona T2/T3 Boost  (SN >600 000)",
  W10809: "Rotor für NSK Ti-Max Z900",
  W10812: "Bundle: w-r.de Reparaturkit + Rotor + Schlüssel",
  W10813: "Universal Dental Ölspray 500ml - 6er Pack",
  W10831: "Mundschutzmaske FFP2/N95",
  W10832: "Chirurgie Maske",
  W11001: "Turbinenschlüssel f. NSK Z900",
  W11002: "Turbinenschlüssel KaVo 637",
  W11003: "Turbinenschlüssel Bien Air Bora",
  W11004: "Turbinenschlüssel KaVo 5000 / M9000",
  W11005: "Turbinenschlüssel NSK Ti-Max X500 / X700",
  W11006: "Turbinenschlüssel NSK Ti-Max X600",
  W11007: "Turbinenschlüssel Sirona T1 Control (TC3)",
  W11008: "Turbinenschlüssel Sirona T2/T3 Racer",
  W11009: "Turbinenschlüssel W&H Synea TA 97 LED / TA 98 LED",
  W11010: "Turbinenschlüssel W&H Synea TA 98 / TA 96",
  W11011: "3-pack Reinigungsnadel",
  W11012: "Turbinendeckel KaVo 625 / 630",
  W11013: "Turbinendeckel KaVo 640",
  W11014: "Turbinendeckel Bien Air Bora",
  W11015: "Turbinendeckel KaVo 637B",
  W11016: "Turbinendeckel KaVo 647B / 649B / 650",
  W11017: "Turbinendeckel KaVo 8000 / M9000",
  W11018: "Turbinendeckel KaVo 655 / 660 / 7000",
  W11019: "Turbinendeckel W&H Synea TA 98",
  W11020: "Turbinendeckel W&H Synea TA 98 LED",
  W11021: "Turbinenschlüssel NSK S-Max M600",
};
